import { useEffect, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// import { logoutUser } from '../store/slices/UserSlice';
import { clearUser } from '../store/slices/UserSlice';

import { toast } from 'react-toastify';

const useIdleLogout = (idleTimeMinutes = 60) => {
  const { userObj } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const idleTimerRef = useRef(null);
  const lastActivityRef = useRef(Date.now());
  const lastLoginRef = useRef(0);
  const isInitializedRef = useRef(false);

  const checkIdle = useCallback(() => {
    const now = Date.now();
    const idleTime = now - lastActivityRef.current;
    
    if (idleTime >= idleTimeMinutes * 60 * 1000) {
      // Don't logout if logged in recently (within 5 minutes)
      if (now - lastLoginRef.current < 5 * 2 * 1000) return;
    
      // Logout on idle
      toast.info('You have been logged out due to inactivity.', { 
        autoClose: 2000,
        position: 'top-center',
        theme: 'dark',
        });
      // setTimeout(() => {
      //     dispatch(logoutUser({
      //       userId: userObj?.userId,
      //       userIdentifier: userObj?.userEmail,
      //     }));
      // }, 2000);
   setTimeout(() => {
  dispatch(clearUser());
}, 2000);

    }
  }, [idleTimeMinutes, dispatch, userObj]);

  const resetTimer = useCallback(() => {
    lastActivityRef.current = Date.now();
    if (idleTimerRef.current) {
      clearTimeout(idleTimerRef.current);
    }
    idleTimerRef.current = setTimeout(checkIdle, idleTimeMinutes * 60 * 1000);
  }, [idleTimeMinutes, checkIdle]);

  useEffect(() => {
    if (!userObj ) {
      // Clean up if no user
      if (idleTimerRef.current) {
        clearTimeout(idleTimerRef.current);
      }
      isInitializedRef.current = false;
      return;
    }

    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];

    const handleActivity = () => {
      resetTimer();
    };

    // Delay initialization on fresh login to avoid interfering with navigation
    const initDelay = !isInitializedRef.current ? 100 : 0;
    
    const initTimer = setTimeout(() => {
      lastLoginRef.current = Date.now();
      isInitializedRef.current = true;

      events.forEach(event => {
        document.addEventListener(event, handleActivity, true);
      });

      resetTimer(); // Start the timer
    }, initDelay);

    return () => {
      clearTimeout(initTimer);
      events.forEach(event => {
        document.removeEventListener(event, handleActivity, true);
      });
      if (idleTimerRef.current) {
        clearTimeout(idleTimerRef.current);
      }
    };
  }, [userObj, resetTimer]);

};

export default useIdleLogout;